import { User } from '@project44/ui-utils';

import {
  ENVIRONMENT,
  PORTAL_V2_DASHBOARD,
  VOC_ORIGIN,
  WHITELISTED_REDIRECT_URL_REGEX,
} from '../constants';

export const getRedirectUriFromQueryParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const redirectUri = searchParams.get('redirect_uri') || '';
  return redirectUri;
};

export const redirectAfterLogin = async (principalData: User) => {
  const tenantSettingForDefaultLanding =
    principalData.customerProperties.DEFAULT_LANDING_URL_AFTER_LOGIN || '';

  const defaultLandingAfterLogin = isRedirectUriWhitelisted(
    tenantSettingForDefaultLanding,
  )
    ? tenantSettingForDefaultLanding
    : PORTAL_V2_DASHBOARD;
  const redirectUriFromQueryAndProperty = getRedirectUriFromQueryAndProperty(
    defaultLandingAfterLogin,
  );

  localStorage.removeItem('redirectUri');
  const redirectUri = isRedirectUriWhitelisted(redirectUriFromQueryAndProperty)
    ? redirectUriFromQueryAndProperty
    : defaultLandingAfterLogin;
  window.location.assign(redirectUri);
};

const getRedirectUriFromQueryAndProperty = (
  defaultLandingAfterLogin: string,
) => {
  const redirectUriFromStorage = localStorage.getItem('redirectUri') || '';
  if (
    (redirectUriFromStorage &&
      doesRedirectUriMatchDefaultOrigin(redirectUriFromStorage)) ||
    !redirectUriFromStorage
  ) {
    return redirectUriFromStorage &&
      defaultLandingAfterLogin === PORTAL_V2_DASHBOARD
      ? redirectUriFromStorage
      : defaultLandingAfterLogin;
  } else {
    return redirectUriFromStorage;
  }
};

const doesRedirectUriMatchDefaultOrigin = (redirectUriFromStorage: string) => {
  const originUrl = getOriginFromUri(redirectUriFromStorage);
  return originUrl === VOC_ORIGIN;
};

const getOriginFromUri = (uri: string) => {
  let url: URL;
  try {
    url = new URL(uri);
  } catch (error) {
    return '';
  }
  return url.origin;
};

const isRedirectUriWhitelisted = (redirectUri: string) => {
  const originUrl = getOriginFromUri(redirectUri);
  if (!originUrl) return false;
  const whitelistedUrlsRegex = WHITELISTED_REDIRECT_URL_REGEX[ENVIRONMENT];
  return whitelistedUrlsRegex?.some((urlRegex: string) =>
    new RegExp(urlRegex).test(originUrl),
  );
};
